module.exports = __webpack_public_path__ + "img/pin.3bf62a4e.svg";